import React from "react";
import { ButtonGroup, Col, Form, Row, ToggleButton } from "react-bootstrap";
import HelpButton from "../HelpContent/HelpButton";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { toast } from "react-toastify";

export default function PingCheck({ checkType, check, setCheck }) {
  return (
    <div className="align-items-center rounded-3 p-4 px-5 mx-auto bg-purple-gradient-darker-reverse ">
      <div className="mb-3">
        <div className="d-flex justify-content-between mb-3">
          <div>
            <span className="fs-4 fw-bold text-capitalize">
              {checkType === "liveness"
                ? "Status Check Response"
                : "Recovery Check Response"}
              <HelpButton helpKey={`monitoring-${checkType}-check`} />
            </span>
          </div>
          <div>
            {checkType === "recovery" && (
              <Form.Check
                type="switch"
                id="recovery-switch"
                label=""
                checked={check.IsActive}
                onChange={(e) =>
                  setCheck({ ...check, IsActive: e.target.checked })
                }
              />
            )}
          </div>
        </div>
        {checkType === "liveness" && (
          <div className="bg-white rounded-3 p-3 mb-3">
            <div className="fw-bold">About Status Check</div>
            This check will be performed at the configured interval to ensure
            that your service is up and running. If the check fails, an alert
            will be triggered based on your alert configuration.
          </div>
        )}
        {checkType === "recovery" && (
          <div className="bg-white rounded-3 p-3 mb-3">
            <div className="fw-bold">About Recovery Check</div>
            If configured, this check will be performed until the failure has
            been recovered.
          </div>
        )}
        {(checkType === "liveness" || check.IsActive) && (
          <div className="align-items-center rounded-3 bg-purple-gradient-darker-reverse mx-auto">
            <div className="">
              <div className="">
                <Form.Group as={Row} className="mb-3" controlId="responseCode">
                  <Form.Label className="fw-bold" column md={5}>
                    Expect response code:
                  </Form.Label>
                  <Col>
                    <Input
                      isMulti
                      label=""
                      onChange={(values) => {
                        if (!values || values.length === 0) {
                          toast.error(
                            "You must specify at least one success code."
                          );
                          return;
                        }
                        setCheck({
                          ...check,
                          SuccessCodes: values.map(Number),
                        });
                      }}
                      value={check.SuccessCodes || []}
                      isValidNewOption={(v) =>
                        v.trim() && !isNaN(Number(v.trim()))
                      }
                    />
                  </Col>
                </Form.Group>
              </div>
              <div className="">
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="responseBodyToggle"
                >
                  <Form.Label className="fw-bold" column md={5}>
                    Response body must:
                  </Form.Label>
                  <Col className="text-nowrap">
                    <ButtonGroup>
                      <ToggleButton
                        id={`radio-ignore-${checkType}`}
                        type="radio"
                        variant="secondary"
                        name={`must-radio-${checkType}`}
                        value="ignore"
                        checked={check.MatchBodyMethod === "ignore"}
                        onChange={(e) =>
                          setCheck({
                            ...check,
                            MatchBodyMethod: e.currentTarget.value,
                          })
                        }
                      >
                        ignore
                      </ToggleButton>
                      <ToggleButton
                        id={`radio-contain-${checkType}`}
                        type="radio"
                        variant="secondary"
                        name={`must-radio-${checkType}`}
                        value="contains"
                        checked={check.MatchBodyMethod === "contains"}
                        onChange={(e) =>
                          setCheck({
                            ...check,
                            MatchBodyMethod: e.currentTarget.value,
                          })
                        }
                      >
                        contains
                      </ToggleButton>
                      <ToggleButton
                        id={`radio-exact-${checkType}`}
                        type="radio"
                        variant="secondary"
                        name={`must-radio-${checkType}`}
                        value="exact"
                        checked={check.MatchBodyMethod === "exact"}
                        onChange={(e) =>
                          setCheck({
                            ...check,
                            MatchBodyMethod: e.currentTarget.value,
                          })
                        }
                      >
                        exact match
                      </ToggleButton>
                    </ButtonGroup>
                  </Col>
                </Form.Group>
              </div>
              <div className="">
                <Form.Group className="mb-3" controlId="responseTextArea">
                  <Form.Control
                    readOnly={check.MatchBodyMethod === "ignore"}
                    disabled={check.MatchBodyMethod === "ignore"}
                    as="textarea"
                    value={check.MatchBody}
                    onChange={(e) =>
                      setCheck({ ...check, MatchBody: e.target.value })
                    }
                  />
                </Form.Group>
                {check.MatchBodyMethod !== "ignore" && (
                  <div>
                    <span className="text-secondary">
                      The response body must{" "}
                      {check.MatchBodyMethod === "contains"
                        ? "contain"
                        : "exactly match"}{" "}
                      the text above for the check to be considered successful.
                      <br />
                      The first 64kB of the response body will be evaluated.
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}{" "}
      </div>
    </div>
  );
}
